import { FC } from "react";
import { FieldTypes } from "lib/types";
import { Icon } from '@chakra-ui/react';
import { MenuItem } from "@chakra-ui/menu";
import { FontIcon } from "lib/icons/font";
import { HtmlIcon } from "lib/icons/html";
import { BsPlusSquare } from '@react-icons/all-files/bs/BsPlusSquare';
import { BsLink45Deg } from '@react-icons/all-files/bs/BsLink45Deg';

const ICON_SIZE = '20px';

type Props = {
  type: FieldTypes,
  create: Function;
};

const draftAsset: Record<Exclude<FieldTypes, FieldTypes.FILE | FieldTypes.UNKNOWN>, { text: string, icon: JSX.Element }> = {
  [FieldTypes.HTML]: {
    text: 'Add HTML',
    icon: <HtmlIcon boxSize={ICON_SIZE} />,
  },
  [FieldTypes.TEXT]: {
    text: 'Add text',
    icon: <FontIcon boxSize={ICON_SIZE} />,
  },
  [FieldTypes.LINK]: {
    text: 'Add link',
    icon: <Icon as={BsLink45Deg} boxSize={ICON_SIZE} />,
  },
  [FieldTypes.PROMPT]: {
    text: 'Add dropzone',
    icon: <Icon as={BsPlusSquare} boxSize={"16px"} ml={"1px"} />,
  },
}

export const CreateDraftAssetMenuItem: FC<Props> = ({ type, create }) => {
  const { text, icon } = draftAsset[type];

  return (
    <MenuItem onClick={() => create(type)} icon={icon} alignItems={"center"}>
      { text }
    </MenuItem>
  )
};
